import { render, staticRenderFns } from "./ScalingMerit.html?vue&type=template&id=02756e45&external"
import script from "./ScalingMerit.ts?vue&type=script&lang=ts&external"
export * from "./ScalingMerit.ts?vue&type=script&lang=ts&external"
import style0 from "./ScalingMerit.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports